document.addEventListener("DOMContentLoaded", function () {
  const anchorElements = document.querySelectorAll(
    ".variant__grid--small a,.variant__grid--small img,.see__all--grid img,.see__all--grid a"
  );
  const originalTitles = document.querySelectorAll(
    ".variant__head span,.product-hover-title span"
  );
  document.addEventListener("mouseover", function (e) {
    if (e.target.classList.contains("product-color-tile")) {
      const originalTitlesDrawer = document.querySelectorAll(
        ".variant__head span,.product-hover-title span"
      );
      originalTitlesDrawer.forEach((originalTitle) => {
          originalTitle.innerHTML = e.target.title;
      });
    }
  });

  anchorElements.forEach(function (anchor) {
    anchor.addEventListener("mouseover", function () {
      originalTitles.forEach((originalTitle) => {
        originalTitle.innerHTML = anchor.title;
      });
    });

    anchor.addEventListener("mouseout", function () {});
  });
 
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    // this.updatePickupAvailability();
    // this.removeErrorMessage();
    this.updateVariantStatuses();
     this.checkSelections();
    if (!this.currentVariant?.available) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      // this.updateURL();
      this.updateVariantInput();
      // this.renderProductInfo();
      // this.updateShareUrl();
    }
    
  }

  checkSelections() {
    const totalSelectors = document.querySelectorAll("variant-radios").length;

    var radioGroup1Selected =
      document.querySelectorAll('variant-radios input[type="radio"]:checked')
        .length === totalSelectors;

    var submitButton = document.querySelector(".atc.product-form__btns");
// debugger
    // Enable the button only if exactly two options are selected
     //submitButton.disabled = !radioGroup1Selected;
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    const drawer = this.closest(
      ".product-information-drawer"
    )

    //drawer.unmount();

    // const overlay = document.querySelector('#BodyOverlay')
    // overlay.style.zIndex=''
    // overlay.style.backgroundColor=''
    // overlay.style.backdropFilter=''
    // overlay.style.pointerEvents=''
    // overlay.removeAttribute('visible')
    var e = document.body.style.top;
    document.body.removeAttribute("scroll-y-off")
                document.body.style.top = ""
                // window.scrollTo(0, -1 * parseInt(e || "0"))
    //drawer.setAttribute("data-aria-expanded",false)
      const closeButton = drawer.querySelector(`button`);
    console.log("clicked...")
    closeButton && closeButton.click();
   const variantPickers = document.querySelectorAll(
      `.product-variant-${this.dataset.section}`
    );

    variantPickers.forEach((picker) => {
      const title = picker.querySelector("span");
      title.innerHTML = this.currentVariant.title;
    });

    const forms = document.querySelectorAll(".bundle-form");
    const addButton = document.querySelector(".atc.product-form__btns");

    addButton.removeAttribute("disabled");

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    forms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      // input.value = this.currentVariant.id;
      if (!input.value) addButton.setAttribute("disabled", "disabled");
    });
    document.querySelector('.variant__grid--large ul') ? document.querySelector('.variant__grid--large ul').scrollLeft += 200 : '';
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
        input.removeAttribute("disabled");
        
        input.labels[0].classList.remove("disabled");
        input.labels[0].removeAttribute('disabled')
      } else {
        input.classList.add("disabled");
        input.setAttribute('disabled','disabled')
        input.labels[0].classList.add("disabled");
        input.labels[0].setAttribute('disabled','disabled')
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      )?.value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

function updateCartCount() {
  // Make a Fetch API request to fetch the cart.
  fetch("/cart.js", {
    method: "GET",
    headers: {
      "X-Requested-With": "XMLHttpRequest", // This header is required for the Shopify cart API.
    },
  })
    .then((response) => response.text())
    .then((t) => {
      // Extract the total item count from the cart data.
      document.getElementsByTagName("cart-drawer")[0].open();
      // document.getElementsByTagName('cart-drawer')[0].get()
      // document.getElementsByTagName('cart-drawer')[0].updateCart(t)
      document.getElementsByTagName("cart-drawer")[0].handleCartChange(t);
      document.getElementsByTagName("cart-drawer")[0].mount();
      var e = document.getElementsByTagName("cart-drawer")[0];
      // e.updateCart(t)
      // e.cartDrawer
      // e.updateCartDrawerByParsedState(t)
      // e.updatePopupByParsedState(t)
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    });
}




document
  .querySelector(".product-form__btn-wrapper--sticky-mobile-button .product-form__btns ")
  ?.addEventListener("click", (e) => {
    e.preventDefault();

    const forms = document.querySelectorAll(".bundle-form");
    const addButton = document.querySelector("button.product-form__btns");

    addButton.removeAttribute("disabled");


    forms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      // input.value = this.currentVariant.id;
      if (!input.value) {
        addButton.setAttribute("disabled", "disabled");
        var element = document.querySelector('.custom__variant--picker');
      
        // Check if the element is found
        if (element) {
            // Scroll to the element
            element.scrollIntoView({ behavior: 'smooth' });
        } else {
            console.log('Element not found');
        }
      }else{
        document
  .querySelector(".atc.product-form__btns").click()
      }
    });

  })
    const handleATCClick = (e) => {
    e.preventDefault();

    const targetForm = e.target.closest("product-form");
    const productForm = document.querySelectorAll(".bundle-form .variant-id");
    const ids = [];
    const formData = new FormData();

    productForm?.forEach((t) => {
      ids.push({ id: t.value, quantity: 1 });

      formData.append("id", t.value);
      formData.append("quantity", 1);
      formData.append("sections_url", window.location.pathname);
    });

    const gvCartDrawer = document.querySelector("#CartDrawer");
    const cartDrawerSection = gvCartDrawer.getAttribute("data-section-id");

    const addData = {
      items: ids,
      sections: [
        cartDrawerSection,
        "cart",
        "cart-notification-popup-content",
      ],
      sections_url: window.location.pathname,
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(addData),
    })
      .then((t) => t.json())
      .then((t) => {
    //         const drawer = targetForm.closest(
    //   ".product-information-drawer"
    // )
        // use the element's id (e.g. <float-element id="MyDrawer">...</float-element>)
        const drawer = targetForm.closest(
      ".product-information-drawer"
    )
        if (drawer) {
          if (typeof drawer.hide === 'function') {
            drawer.hide();           // preferred: triggers component hide + overlay handling
          } else {
            // fallback (less ideal): set aria-hidden and update overlay
            drawer.setAttribute('aria-hidden', 'true');
            if (window.Nt) window.Nt.hideOverlay(drawer.id);
          }
        }

        const cartDrawer = document.querySelector("#CartDrawer");
        cartDrawer.purchaseHandler(t);
        cartDrawer.open();
        // debugger
      })
      .catch((error) => console.error("Error fetching cart data:", error));
  };

const initATCButton = () => {
  const forms = document.querySelectorAll(".bundle-form");
    const addButton = document.querySelector(".atc.product-form__btns");

    addButton.removeAttribute("disabled");

    forms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      // input.value = this.currentVariant.id;
      if (!input.value) addButton.setAttribute("disabled", "disabled");
    });
}


const drawerATCOpen = () => {
  const atcBtn = document.querySelector(".atc.product-form__btns");
  if (!atcBtn) return;

  atcBtn.addEventListener("click", handleATCClick);
  setupFitSizeBehavior();
  initATCButton();
};

const drawerATCclose = () =>{
    const atcBtn = document.querySelector(".atc.product-form__btns");
  if (!atcBtn) return;
  atcBtn.removeEventListener("click", handleATCClick);
}

 const atcBtn = document.querySelector(".atc.product-form__btns");
  if (atcBtn) atcBtn.addEventListener("click", handleATCClick);

/* ATC from cartdrawer for upsell product*/
$(document).on('click','.upsell_atc',function(){
    var prodId = $(this).attr('data-prodid');
    var variantID = $('[data-varprodid="'+prodId+'"]').val();
    const gvCartDrawer = document.querySelector("#CartDrawer");
    var cartDrawerSection = gvCartDrawer.getAttribute("data-section-id");
    var handle = $(this).attr('data-handle')
  
  var upsellData = {
     id: variantID,
     quantity: 1   
  }
  
   var upselladdData = {
      items: [upsellData],
      sections: [
        cartDrawerSection,
        "cart",
        "cart-notification-popup-content",
      ],
      sections_url: "/products/"+handle+"",
    };
  
   fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(upselladdData),
    })
      .then((t) => {
        return t.json();
      })
      .then((t) => {
        const cartDrawer = document.querySelector("#CartDrawer");
        cartDrawer.purchaseHandler(t);
        cartDrawer.open();
        //updateCartCount();
      })
      .catch((error) => {
        console.error("Error fetching cart data:", error);
      });
})



function setupFitSizeBehavior() {
  const forms = document.querySelectorAll('variant-radios');
  if (!forms.length) return;

  forms.forEach(form => {
    const allGroups = form.querySelectorAll('.product-form__input');
    if (allGroups.length === 0) return;

    let fitGroup = null;
    let sizeGroup = null;

    allGroups.forEach(group => {
      const legend = group.querySelector('legend');
      if (!legend) return;
      const labelText = legend.textContent.trim().toLowerCase();

      if (labelText.includes('pasform') || labelText.includes('fit')) {
        fitGroup = group;
      } else if (labelText.includes('størrelse') || labelText.includes('size')) {
        sizeGroup = group;
      }
    });

    if (!sizeGroup) return;

    if (fitGroup) {
      sizeGroup.style.display = 'none';
      const fitRadios = fitGroup.querySelectorAll('input[type="radio"]');
      fitRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          sizeGroup.style.display = 'block';
        });
      });
    } else {
      sizeGroup.style.display = 'block';
    }
  });
}

document.addEventListener('DOMContentLoaded', setupFitSizeBehavior);
document.addEventListener('shopify:section:load', setupFitSizeBehavior);